import tippy from "tippy.js";

// Tooltip
const tippySizeFilterElement = document.querySelector("[data-tooltip-size]");

if (tippySizeFilterElement) {
  const tippySizeFilter = tippy(tippySizeFilterElement, {
    trigger: "click",
    allowHTML: true,
    content: `
        <div class="tippy-box__container">
            <div class="tippy-box__text">
              <p><strong>Global Fit</strong> is redesigned eyewear for improved fit and comfort, especially suited for Asian facial structures.</p>
            </div>
            
            <div class="tippy-box__wrapper">
                <div class="tippy-box__text">
                    <p><strong>Size</strong> is determined by the width of your face.</p>
                    <p>If you already wear glasses, we recommend looking at your current pair as a size reference.</p>
                    <p>Most eyewear brands write their size on the inside of the temple.</p>
                </div>
        
                <img src="https://orgreenoptics.com//themes/orgreen/assets/img/others/tooltip/size.png" alt="55x17x140" title="55x17x140" width="124" height="95">
            </div>
        </div>
        `,
    arrow: false,
    theme: "size",
    placement: "bottom-start",
    zIndex: 999999999,
  });

  if (device.type === "desktop") {
    tippySizeFilter.setProps({
      trigger: "mouseenter focus",
    });
  } else {
    tippySizeFilter.setProps({
      trigger: "click",
    });
  }
}
